/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryEffectiveAnnualCostFigures
 */
export interface ProposalSummaryEffectiveAnnualCostFigures {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProposalSummaryEffectiveAnnualCostFigures
     */
    charges: { [key: string]: number; };
}

/**
 * Check if a given object implements the ProposalSummaryEffectiveAnnualCostFigures interface.
 */
export function instanceOfProposalSummaryEffectiveAnnualCostFigures(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "charges" in value;

    return isInstance;
}

export function ProposalSummaryEffectiveAnnualCostFiguresFromJSON(json: any): ProposalSummaryEffectiveAnnualCostFigures {
    return ProposalSummaryEffectiveAnnualCostFiguresFromJSONTyped(json, false);
}

export function ProposalSummaryEffectiveAnnualCostFiguresFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryEffectiveAnnualCostFigures {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'charges': json['Charges'],
    };
}

export function ProposalSummaryEffectiveAnnualCostFiguresToJSON(value?: ProposalSummaryEffectiveAnnualCostFigures | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Charges': value.charges,
    };
}

